var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneRus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_203_8124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_203_8124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 22,
    height: 16,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_203_8124",
    transform: "matrix(0.00397417 0 0 0.00546448 -0.0464481 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_203_8124",
    width: 275,
    height: 183,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAIAAAC+MS2jAAACKUlEQVR4nO3XwQkCQRBFwV1ZPQhG4ME4zMlMDUgQdI3BdxkGqiL4lwfd677vC/Cnw+gBMCXlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDxbosj9EbYD7b6XoZvQHm41qDQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQKAcK5UChHCiUA4VyoFAOFMqBQjlQbO/PcfQGmM/6vN9Gb4D5bK/vefQGmI8/BwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKJQDhXKgUA4UyoFCOVAoBwrlQKEcKH7AQwonjIcwVQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRus);
export default __webpack_public_path__ + "static/media/phone-rus.1d62779fc62f3829d56ae8900dfb2420.svg";
export { ForwardRef as ReactComponent };